import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Leaf } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      try {
        if (!sessionId) throw new Error("no session id");
        const { data } = await api.post(
          "/auth/google/session",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        setUser(data);
        window.history.replaceState({}, document.title, "/app");
        navigate("/app", { replace: true, state: { user: data } });
      } catch {
        navigate("/login", { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAF8]">
      <div className="flex flex-col items-center gap-3" data-testid="auth-callback-loading">
        <Leaf className="h-8 w-8 text-[#275C3F] animate-pulse" />
        <p className="text-sm text-[#4B5950]">Signing you in…</p>
      </div>
    </div>
  );
}
